module.exports = __webpack_public_path__ + "img/course.8a06a44e.png";